import React, { useMemo } from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import BarChart from 'js/components/Charts/BarChart';
import HorizontalBarChart from 'js/components/Charts/HorizontalBarChart';
import { Icon } from 'js/components';
import {
  TILE_PRESENTATION,
  getChoiceTallyData,
  liveTilePresentation,
} from '../utilities';
import CommentWordCloud from './CommentWordCloud';

function getChart(title, data, width, height, duration, type) {
  const chartProps = {
    title,
    data,
    width,
    height,
    duration,
  };

  switch (type) {
    case 'bar':
      return <BarChart key={data.length} {...chartProps} />;

    case 'horizontal-bar':
    default: {
      const { height: _height, ...horizontalProps } = chartProps;
      return <HorizontalBarChart key={data.length} {...horizontalProps} />;
    }
  }
}

const VoteTally = (props) => {
  const presentation = liveTilePresentation(props.question);
  const isCompletion = presentation === TILE_PRESENTATION.COMPLETION;
  const responses = props.responses || [];
  const data = useMemo(
    () => getChoiceTallyData(props.question, responses),
    [props.question, responses]
  );

  const resultCount = isCompletion
    ? responses.filter((r) => !r?.is_na && r.value).length
    : _.sumBy(data, 'count');

  const classes = {
    'vote-tally': true,
    'no-results': resultCount === 0,
    'vote-tally-compact': props.display === 'compact',
    'vote-tally-comments': isCompletion,
  };

  if (props.type) {
    classes[props.type] = true;
  } else {
    classes['horizontal-bar'] = true;
  }

  return (
    <div className={classnames(classes)}>
      <div className="vote-tally-chart">
        {isCompletion ? (
          <CommentWordCloud
            responses={responses}
            width={
              props.display === 'compact'
                ? props.width
                : Math.max(props.width, 180)
            }
            height={
              props.display === 'compact'
                ? props.height
                : Math.max(props.height, 120)
            }
          />
        ) : (
          getChart(
            props.title,
            data,
            props.width,
            props.height,
            props.duration,
            props.type
          )
        )}
        {resultCount > 0 ? null : (
          <div className="no-results-label">
            <div className="no-results-wrapper">
              <div className="no-results-icon">
                <Icon icon="check" size="4x" />
                <span className="no-results-text">No results</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

VoteTally.defaultProps = {
  width: 100,
  height: 100,
  duration: 1000,
  countdown: 20000,
};

export default VoteTally;
